
import React from 'react';

const EmailTemplate = ({
  recipientName,
  contractTitle,
  contractId,
  contractType,
  clientName,
  projectName,
  departmentName,
  region,
  startDate,
  endDate,
  renewalDate,
  creatorName,
  creationDate,
  previousStatus,
  userName,
  actionDate,
  actionReason,
  contractUrl,
  templateType,
  status,
  partyLabel = "Client Name",
}) => {
  const currentYear = new Date().getFullYear();

  const getEmailBody = () => {
    if (templateType === 'create') {
      return `
        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f5f5f5;">
          <tr>
            <td align="center" style="padding: 20px 0;">
              <table width="600" cellpadding="0" cellspacing="0" border="0" style="background-color: #ffffff; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                <!-- Header -->
                <tr>
                  <td style="background-color: #ff6b35; padding: 30px 20px; text-align: center;">
                    <h1 style="margin: 0; font-size: 28px; font-weight: bold; color: #ffffff;">
                      <span style="color: #ffffff;">CRITICAL</span>RIVER
                    </h1>
                    <p style="margin: 10px 0 0 0; color: rgba(255,255,255,0.9); font-size: 14px;">Contract Lifecycle Management</p>
                  </td>
                </tr>
                <!-- Body -->
                <tr>
                  <td style="padding: 40px 30px; background-color: #ffffff;">
                    <h2 style="margin: 0 0 20px 0; color: #333333; font-size: 20px;">✅ New Contract Created Successfully</h2>
                    <p style="margin: 0 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">Dear ${recipientName || 'User'},</p>
                    <p style="margin: 0 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">We're pleased to inform you that a new contract has been successfully created in the CriticalRiver CLM system. Please find the contract details below:</p>
                    <!-- Contract Card -->
                    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f8f9fa; border-radius: 8px; border: 2px solid #ff6633; margin: 24px 0;">
                      <tr>
                        <td style="padding: 24px;">
                          <h3 style="margin: 0 0 16px 0; color: #333333; font-size: 18px; display: flex; align-items: center;">📄 Contract Details</h3>
                          <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; width: 45%; font-size: 15px;">Contract Title:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;"><strong>${contractTitle || 'N/A'}</strong></td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Contract Type:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${contractType || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Contract ID:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">#${contractId || 'N/A'}</td>
                            </tr>
                            <tr>
                             <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">${partyLabel}:</td>

                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${clientName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Project:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${projectName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Owner Department:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${departmentName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Region:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${region || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Contract Period:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${startDate || 'N/A'} to ${endDate || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Renewal Date:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${renewalDate || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px; border-radius:6px";>Status:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">
                                <span style="display: inline-block; padding: 4px 12px; background-color: #ffa500; color: #ffffff; border-radius: 4px; font-size: 12px; font-weight: 600;">${status || ''}</span>
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Created By:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${creatorName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; font-weight: 600; color: #555555; font-size: 15px;">Created On:</td>
                              <td style="padding: 10px 0; color: #666666; font-size: 15px;">${creationDate || 'N/A'}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                    <!-- CTA Button -->
                    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin: 20px 0;">
                      <tr>
                        <td align="center">
                          <a href="${contractUrl || '#'}" style="display: inline-block; background-color: #ff6633; color: #ffffff; padding: 14px 32px; text-decoration: none; border-radius: 6px; font-weight: 600; font-size: 15px;border-radius:6px;">View Contract</a>
                        </td>
                      </tr>
                    </table>
                    
                    <p style="margin: 0 0 5px 0; color: #666666; line-height: 1.6; font-size: 15px;">Best regards,</p>
                    <p style="margin: 0; color: #666666; line-height: 1.6; font-size: 15px;"><strong>The CriticalRiver BTG Team</strong></p>
                  </td>
                </tr>
                <!-- Footer -->
                <tr>
                  <td style="background-color: #2c3e50; padding: 20px; text-align: center;">
                    <p style="margin: 0 0 10px 0; color: #bbbbbb; font-size: 13px;">&copy; ${currentYear} CriticalRiver. All rights reserved.</p>
                    
                    <p style="margin: 10px 0 0 0; color: #bbbbbb; font-size: 13px;">This is an automated notification from CriticalRiver BTG Team</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      `;
    } else if (templateType === 'create-uploaded') {
      return `
        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f5f5f5;">
          <tr>
            <td align="center" style="padding: 20px 0;">
              <table width="600" cellpadding="0" cellspacing="0" border="0" style="background-color: #ffffff; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                <!-- Header -->
                <tr>
                  <td style="background-color: #ff6b35; padding: 20px 30px; text-align: center;">
                    <h1 style="margin: 0; font-size: 28px; font-weight: bold; color: #ffffff;">
                      <span style="color: #ffffff;">CRITICAL</span>RIVER
                    </h1>
                    <p style="margin: 10px 0 0 0; color: rgba(255,255,255,0.9); font-size: 14px;">Contract Lifecycle Management</p>
                  </td>
                </tr>
                <!-- Body -->
                <tr>
                  <td style="padding: 40px 30px; background-color: #ffffff;">
                    <h2 style="margin: 0 0 20px 0; color: #333333; font-size: 24px;">✅ New Uploaded Document Contract Created Successfully</h2>
                    <p style="margin: 0 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">Dear ${recipientName || 'User'},</p>
                    <p style="margin: 0 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">We're pleased to inform you that a new uploaded document contract has been successfully created in the CriticalRiver CLM system. Please find the contract details below:</p>
                    <!-- Contract Card -->
                    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f8f9fa; border-radius: 8px; border: 2px solid #ff6633; margin: 24px 0;">
                      <tr>
                        <td style="padding: 24px;">
                          <h3 style="margin: 0 0 16px 0; color: #333333; font-size: 18px; display: flex; align-items: center;">📄 Contract Details</h3>
                          <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; width: 45%; font-size: 15px;">Contract Title:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;"><strong>${contractTitle || 'N/A'}</strong></td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Contract Type:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${contractType || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Contract ID:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">#${contractId || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">${partyLabel}:</td>

                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${clientName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Project:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${projectName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Owner Department:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${departmentName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Region:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${region || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Contract Period:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${startDate || 'N/A'} to ${endDate || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Renewal Date:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${renewalDate || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Status:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">
                                <span style="display: inline-block; padding: 4px 12px; background-color: #ffa500; color: #ffffff; border-radius: 4px; font-size: 12px; font-weight: 600;border-radius:6px;">${status || ''}</span>
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Created By:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${creatorName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; font-weight: 600; color: #555555; font-size: 15px;">Created On:</td>
                              <td style="padding: 10px 0; color: #666666; font-size: 15px;">${creationDate || 'N/A'}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                    <!-- CTA Button -->
                    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin: 20px 0;">
                      <tr>
                        <td align="center">
                          <a href="${contractUrl || '#'}" style="display: inline-block; background-color: #ff6633; color: #ffffff; padding: 14px 32px; text-decoration: none; border-radius: 6px; font-weight: 600; font-size: 15px;border-radius:6px;">View Contract</a>
                        </td>
                      </tr>
                    </table>
                    
                    <p style="margin: 0 0 5px 0; color: #666666; line-height: 1.6; font-size: 15px;">Best regards,</p>
                    <p style="margin: 0; color: #666666; line-height: 1.6; font-size: 15px;"><strong>The CriticalRiver BTG Team</strong></p>
                  </td>
                </tr>
                <!-- Footer -->
                <tr>
                  <td style="background-color: #2c3e50; padding: 20px; text-align: center;">
                    <p style="margin: 0 0 10px 0; color: #bbbbbb; font-size: 13px;">&copy; ${currentYear} CriticalRiver. All rights reserved.</p>
                    
                    <p style="margin: 10px 0 0 0; color: #bbbbbb; font-size: 13px;">This is an automated notification from CriticalRiver BTG Team</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      `;
    } else if (templateType === 'create-template') {
      return `
        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f5f5f5;">
          <tr>
            <td align="center" style="padding: 20px 0;">
              <table width="600" cellpadding="0" cellspacing="0" border="0" style="background-color: #ffffff; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                <!-- Header -->
                <tr>
                  <td style="background-color: #ff6b35; padding: 20px 30px; text-align: center;">
                    <h1 style="margin: 0; font-size: 28px; font-weight: bold; color: #ffffff;">
                      <span style="color: #ffffff;">CRITICAL</span>RIVER
                    </h1>
                    <p style="margin: 10px 0 0 0; color: rgba(255,255,255,0.9); font-size: 14px;">Contract Lifecycle Management</p>
                  </td>
                </tr>
                <!-- Body -->
                <tr>
                  <td style="padding: 40px 30px; background-color: #ffffff;">
                    <h2 style="margin: 0 0 20px 0; color: #333333; font-size: 24px;">✅ New Template-Based Contract Created Successfully</h2>
                    <p style="margin: 0 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">Dear ${recipientName || 'User'},</p>
                    <p style="margin: 0 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">We're pleased to inform you that a new template-based contract has been successfully created in the CriticalRiver CLM system. Please find the contract details below:</p>
                    <!-- Contract Card -->
                    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f8f9fa; border-radius: 8px; border: 2px solid #ff6633; margin: 24px 0;">
                      <tr>
                        <td style="padding: 24px;">
                          <h3 style="margin: 0 0 16px 0; color: #333333; font-size: 18px; display: flex; align-items: center;">📄 Contract Details</h3>
                          <table width="100%" cellpadding="0" cellspacing="0" border="0">
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; width: 45%; font-size: 15px;">Contract Title:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;"><strong>${contractTitle || 'N/A'}</strong></td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Contract Type:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${contractType || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Contract ID:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">#${contractId || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">${partyLabel}:</td>

                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${clientName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Project:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${projectName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Owner Department:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${departmentName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Region:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${region || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Contract Period:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${startDate || 'N/A'} to ${endDate || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Renewal Date:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${renewalDate || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Status:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">
                                <span style="display: inline-block; padding: 4px 12px; background-color: #ffa500; color: #ffffff; border-radius: 4px; font-size: 12px; font-weight: 600;border-radius:6px;">${status || ''}</span>
                              </td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; font-weight: 600; color: #555555; font-size: 15px;">Created By:</td>
                              <td style="padding: 10px 0; border-bottom: 1px solid #e0e0e0; color: #666666; font-size: 15px;">${creatorName || 'N/A'}</td>
                            </tr>
                            <tr>
                              <td style="padding: 10px 0; font-weight: 600; color: #555555; font-size: 15px;">Created On:</td>
                              <td style="padding: 10px 0; color: #666666; font-size: 15px;">${creationDate || 'N/A'}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                    <!-- CTA Button -->
                    <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin: 20px 0;">
                      <tr>
                        <td align="center">
                          <a href="${contractUrl || '#'}" style="display: inline-block; background-color: #ff6633; color: #ffffff; padding: 14px 32px; text-decoration: none; border-radius: 6px; font-weight: 600; font-size: 15px;">View Contract</a>
                        </td>
                      </tr>
                    </table>
                    
                    <p style="margin: 0 0 5px 0; color: #666666; line-height: 1.6; font-size: 15px;">Best regards,</p>
                    <p style="margin: 0; color: #666666; line-height: 1.6; font-size: 15px;"><strong>The CriticalRiver BTG Team</strong></p>
                  </td>
                </tr>
                <!-- Footer -->
                <tr>
                  <td style="background-color: #2c3e50; padding: 20px; text-align: center;">
                    <p style="margin: 0 0 10px 0; color: #bbbbbb; font-size: 13px;">&copy; ${currentYear} CriticalRiver. All rights reserved.</p>
                    
                    <p style="margin: 10px 0 0 0; color: #bbbbbb; font-size: 13px;">This is an automated notification from CriticalRiver BTG Team</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      `;
    }  
    return '';
  };

  const htmlContent = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${
        templateType === 'create' ? 'New Contract Created' :
        templateType === 'create-uploaded' ? 'New Uploaded Document Contract Created' :
        templateType === 'create-template' ? 'New Template-Based Contract Created' :
        templateType === 'archive' ? 'Contract Moved to Archive' :
        'Contract Restored'
      }</title>
    </head>
    <body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f5f5f5;">
      ${getEmailBody()}
    </body>
    </html>
  `;

  return htmlContent;
};

export default EmailTemplate;
